"use client";
import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const r = (i) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.08 11.6C3.76 7.72 7.569 5 11.998 5s8.237 2.71 9.917 6.6c.11.25.11.55 0 .8-1.68 3.88-5.488 6.6-9.917 6.6-4.43 0-8.238-2.71-9.918-6.6a1 1 0 0 1 0-.8m14.42.4a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M12 14.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5"
        }
      )
    ]
  }
), d = t(r);
export {
  d as VisibilityShow,
  d as default
};
